import React from 'react';

import { Text, Tooltip } from '@mantine/core';

interface ICoachCellProps {
  coachName: string;
}

const CoachCell = ({ coachName }: ICoachCellProps): JSX.Element => {
  const coaches = coachName ? coachName.split(', ') : [];

  if (coaches.length === 0) {
    return <Text>—</Text>;
  }

  if (coaches.length === 1) {
    return <Text>{coaches[0]}</Text>;
  }

  return (
    <Tooltip label={coachName} multiline withinPortal>
      <Text aria-label={coachName}>{`${coaches[0]} +${coaches.length - 1}`}</Text>
    </Tooltip>
  );
};

export default CoachCell;
